"use client"

import classNames from "classnames";
import styles from "./styles/SchoolFeedDisplay.module.scss";
import ClickableLink from "../utilities/ClickableLink";

export function SchoolFeedMobileWidgetLink(props: {
    active: boolean,
    src: string,
    text: string,
    href: string | object,
    className?: string,
}) {
    const linkClassName = classNames({
        [styles.link]: true,
        [styles.linkActive]: props.active,
        [props.className || ""]: !!props.className,
    })
    return <ClickableLink href={props.href} className={linkClassName}>
        <img aria-hidden={true} src={props.src}/>
        {props.text}
    </ClickableLink>
}